import { ChangeDetectionStrategy, Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { AutocompleteInputType, QuestionDefinition } from '../../forms/form.types';
import { GenericFormGroupComponent } from '../../forms/generic-form-group.component';
import { AlertService } from '../../shared/services/alert.service';

@Component({
    selector: 'app-switch-user',
    templateUrl: './switch-user.component.html',
    styleUrls: ['./switch-user.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default
})
export class SwitchUserComponent extends GenericFormGroupComponent implements OnInit {
    controls: {
        user: UntypedFormControl;
    };
    userQuestion: QuestionDefinition;
    loading: boolean;

    constructor(protected renderer2: Renderer2, private alert: AlertService) {
        super(renderer2, false);
    }

    ngOnInit(): void {
        this.controls = {
            user: new UntypedFormControl(null, Validators.required)
        };
        this.createFormGroup(this.controls);
        this.userQuestion = {
            prompts: [
                {
                    text: 'Search users'
                }
            ],
            input: {
                discriminator: 'AUTOCOMPLETE',
                label: 'User to switch to',
                required: true,
                control: this.controls.user,
                display: 'name',
                property: 'netId',
                baseUrl: 'user',
                queryParam: 'term',
                allowAny: true
            } as AutocompleteInputType
        };
    }

    onSubmit(): void {
        this.loading = true;
        const myForm = <HTMLFormElement>document.getElementById('switchUserForm');
        myForm.submit();
    }

    setUserNameAndSubmit(userName: string) {
        this.alert.toastSuccess(`Switching to ${userName} please wait.`);
        this.clearValidators(this.controls.user);
        this.controls.user.setValue(userName);
        this.onSubmit();
    }
}
